<fui-command-pop [popped]="toggled" (popped$)="popped($event)"
                 [parentHorizontalAlignment]="popAlignment" [horizontalOffset]="icon ? 6: 0">
    <ng-content></ng-content>
</fui-command-pop>

@if (!icon) {
    <fui-pop-button [title]="title" [toggled]="toggled">
        @if (hasCommands) {
            <fui-mark-toggle [toggled]="toggled">
                <fui-icon [icon]="'chevron-down'" [height]="6" [width]="12"></fui-icon>
            </fui-mark-toggle>
        }
    </fui-pop-button>
}

@if (icon) {
    <fui-action [attr.title]="title">
        <fui-icon [icon]="icon" [height]="iconSize" [width]="iconSize"></fui-icon>
    </fui-action>
}
